module.exports = __webpack_public_path__ + "media/images/brands/brand-sp-7a735e470a9b7381d4d15a1c08dced35.jpg";